export default __webpack_public_path__ + "static/media/01.4c6a2734.jpg";